"use strict";

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _InstantSearch = _interopRequireDefault(require("./lib/InstantSearch"));

var _version = _interopRequireDefault(require("./lib/version"));

var _helpers = require("./helpers");

var _infiniteHitsCache = require("./lib/infiniteHitsCache");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var instantsearch = function instantsearch(options) {
  return new _InstantSearch["default"](options);
};

instantsearch.version = _version["default"];
instantsearch.snippet = _helpers.snippet;
instantsearch.highlight = _helpers.highlight;
instantsearch.insights = _helpers.insights;
instantsearch.getInsightsAnonymousUserToken = _helpers.getInsightsAnonymousUserToken;
instantsearch.createInfiniteHitsSessionStorageCache = _infiniteHitsCache.createInfiniteHitsSessionStorageCache;
(0, _defineProperty["default"])(instantsearch, 'widgets', {
  get: function get() {
    throw new ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'");
  }
});
(0, _defineProperty["default"])(instantsearch, 'connectors', {
  get: function get() {
    throw new ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'");
  }
});
var _default = instantsearch;
exports["default"] = _default;